<template>
  <div class="cardbox commentarea">
    <!-- No comments -->
    <div class="commentsheight">
      <div v-if="!comments.length" class="centerblockimg">
        <svgicon name="NoComments" width="100px" height="195px" :original="true" />
        <div>No comments yet!</div>
      </div>
      <div v-else class="commentarea-list"
        v-for="(comment, idx) in transformComments(comments)" :key="idx">
        <div v-if="comment.showComment" class="commentprofile">
          <span class="commentprofile-psign">{{ comment.parentTypeInitial }}</span>
          <span class="commentprofile-dt">{{ comment.user_name }}</span>
          <span class="commentprofile-dt">{{ comment.formattedTimestamp }}</span>
          <label v-if="comment.isReturnComment" class="f-right ebtn"> RETURNED </label>
          <label v-if="comment.isCancelComment" class="f-right ebtn"> CANCELLED </label>
          <label v-if="comment.isRejectComment" class="f-right ebtn"> REJECTED </label>
        </div>
        <p v-if="comment.showComment">
          {{ comment.message }}
        </p>
      </div>
    </div>
    <div class="commentarea-inputfield" v-if="!readOnly">
      <textarea placeholder="Add your comment" v-model="comment"></textarea>
    </div>
    <div class="footerbtn actionbtn" v-if="!readOnly">
      <Button type="primary" size="mini" :disabled="!comment" @click="addComment()">{{ $t('SAVE') }}</Button>
    </div>
  </div>
</template>
<script type="text/javascript">
import moment from 'moment';
import { commentParty, commentTitle, responseCode } from 'pando-constants';
import { formatCommentDate } from '@/lib/Date';

export default {
  props: {
    comments: {
      type: Array,
      required: true,
    },
    showRejected: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    moment,
  },
  data() {
    return {
      comment: '',
    };
  },
  methods: {
    transformComments(comments) {
      return comments && comments.map(comment => Object.assign({}, {
        parentTypeInitial: commentParty.SHIPPER === comment.party ? 'S' : 'T',
        formattedTimestamp: formatCommentDate(comment.timestamp),
        message: comment.message,
        isReturnComment: comment.isReturnedComment && comment.title !== commentTitle.INVOICE_CANCELLED && comment.title !== commentTitle.INVOICE_REJECTED,
        isCancelComment: comment.title === commentTitle.INVOICE_CANCELLED,
        isRejectComment: comment.title === commentTitle.INVOICE_REJECTED,
        user_name: comment.user_name,
        showComment: ( comment.title === commentTitle.INVOICE_REJECTED ) ? this.showRejected : true,
      }));
    },

    addComment() {
      const comment = this.comment.trim();
      this.$emit('addComment',comment);
      this.comment = '';
    },
  },
};
</script>
